<form 
	pcgSubmitUrl="api/SetClient" 
	[formGroup]="form" 
	(messageSuccess)="reloadPage($event.value)"
>
	<div class="modal-header">
		<h5 
			class="modal-title" 
			id="modal-basic-title"
		>Change Customer</h5>
		<button 
			type="button" 
			class="close" 
			aria-label="Close" 
			(click)="activeModal.dismiss()"
		>
			<span aria-hidden="true">&times;</span>
		</button>
	</div>
	<div class="modal-body">
		<pcg-select
			[sendFormData]="false"
			pcgControlRef
			dataSource="api/Select/Clients"
			formControlName="clientId"
		></pcg-select>
	</div>
	<div class="modal-footer">
		<button 
			type="button" 
			class="btn btn-cancel btn-lg" 
			(click)="activeModal.dismiss()"
		>Cancel</button>
		<button 
			type="submit" 
			class="btn btn-save btn-lg"
		>Change Customer</button>
	</div>
</form>
